export const lastOrDefaultAsync = async (source, predicate) => {
    let last = null;
    for (const value of source) {
        if (await predicate(value) === true) {
            last = value;
        }
    }
    return last;
};
